import { BaseRequestModel } from '../../base/base.request.model';
import { ProductAppChannelModel } from './product-app-channel-model.model';

export class GetProductsRequestMessage {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  GetProductsRequestMessage!: ProductsRequestMessageModel;
}

export class ProductsRequestMessageModel extends BaseRequestModel {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  dmaID!: string;
  returnAppChannels?: string;
  appChannels?: ProductAppChannelModel;
  returnLocaleDisplayName?: string;
  returnPromotions?: string;
  returnAttributes?: string;
  rateType?: string;
  salesChannel!: string;
  offerType?: string;
  isStore?: boolean;
}
